import React, { useState } from "react";
import { Modal, Button } from "antd";

const CHECKIN_POLICY_SHORT = "ข้อกำหนดและเงื่อนไขการเช็คอิน";

const CHECKIN_POLICY_FULL = `
ทั้งนี้ บริษัทฯ ขอสงวนสิทธิ์ในการเปลี่ยนแปลงรายละเอียดเงื่อนไขต่างๆ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า\n\nกรณีท่านนักกอล์ฟยืนยันการจองแคดดี้ และได้มีการชำระเงินเรียบร้อยรวมถึงทำการเช็คอินเพื่อออกรอบแล้ว ท่านจะไม่สามารถยกเลิกการจองได้ บริษัทฯ ขอสงวนสิทธ์ ไม่มีการคืนเงินไม่ว่ากรณีใด ๆ ทั้งสิ้น
`;

export function CheckinPolicyShowAll() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <span
        onClick={() => setOpen(true)}
        style={{
          cursor: "pointer",
          color: "#bad4d2",
          textDecoration: "underline",
          textUnderlineOffset: 3,
        }}
      >
        {CHECKIN_POLICY_SHORT}
      </span>
      {open && (
        <div
          className="register-termcondition-container"
          style={{ top: "50%" }}
        >
          <div
            className="termcondition-content"
            style={{ overflowY: "scroll" }}
          >
            <center>
              <h2 style={{ marginBottom: 5, marginTop: "auto" }}>
                {CHECKIN_POLICY_SHORT}
              </h2>
            </center>
            <div
              style={{
                padding: 15,
                border: "2px solid #90C7C5",
                borderRadius: 20,
                overflow: "hidden",
              }}
            >
              <div style={{ height: "100%", overflowY: "scroll" }}>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 10 }}
                >
                  <center>
                    <div style={{ whiteSpace: "pre-line" }}>
                      {CHECKIN_POLICY_FULL}
                    </div>
                  </center>
                </div>
              </div>
            </div>
            <center>
              <Button
                onClick={() => setOpen(false)}
                style={{
                  width: "100%",
                  height: 40,
                  marginTop: 10,
                  backgroundColor: "#009951",
                  color: "white",
                }}
                type="primary"
              >
                ปิด
              </Button>
            </center>
          </div>
        </div>
      )}
    </>
  );
}

export function CheckinPolicy() {
  return (
    <center>
      <div style={{ marginTop: 10, lineHeight: "1.35rem" }}>
        โดยการคลิก "เช็คอิน" ฉันได้อ่าน <CheckinPolicyShowAll />
      </div>
    </center>
  );
}

export default CheckinPolicy;
